module.exports = __webpack_public_path__ + "assets/b8eba6a7c085833dea90482a443dd2ed.png";